import { Component } from "@angular/core";

@Component({
  selector: 'tr[app-dt-body-tr]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-body-tr.component.scss'],
})
export class DtBodyTrComponent {}